import React from "react";
import { toast } from "react-toastify";
import { Button, TextInput } from "src/Components";
import { IConfig } from "src/Interfaces/goldArbitrage";
import {
  getConfig,
  setConfig as setGoldArbitrageConfig,
} from "src/Requests/goldArbitrage";
import { packetErrorHandler } from "src/Utils/requestUtils";

const Settings = () => {
  const [config, setConfig] = React.useState({} as IConfig);
  const [maxNavDifferencePercentInput, setMaxNavDifferencePercentInput] =
    React.useState("");
  const [
    maxNavDeltaDifferencePercentInput,
    setMaxNavDeltaDifferencePercentInput,
  ] = React.useState("");

  React.useEffect(() => {
    getConfig()
      .then((data) => {
        setConfig(data);
        setMaxNavDifferencePercentInput(
          data.maxNavDifferencePercent?.toString() || "",
        );
        setMaxNavDeltaDifferencePercentInput(
          data.maxNavDeltaDifferencePercent?.toString() || "",
        );
      })
      .catch(packetErrorHandler);
  }, []);

  const changeHandler = (name: string, value: string) => {
    setConfig({
      ...config,
      [name]: Number(value),
    });
  };

  const submitHandler = () => {
    setGoldArbitrageConfig({
      ...config,
      maxNavDifferencePercent: Number(maxNavDifferencePercentInput),
      maxNavDeltaDifferencePercent: Number(maxNavDeltaDifferencePercentInput),
    })
      .then((resp) => {
        toast.success(resp.msg);
      })
      .catch(packetErrorHandler);
  };

  return (
    <div className="min-h-32 min-w-[300px] w-full flex flex-col justify-center items-center gap-3">
      <TextInput
        label="تعداد روز در میانگین حباب"
        name="windowLength"
        onChange={changeHandler}
        value={config.windowLength?.toString() || ""}
        kind="number"
        extraLabel
      />
      <TextInput
        label="حداکثر اختلاف NAV TSE و NAV محاسباتی (درصد)"
        name="maxNavDifferencePercent"
        onChange={(_, value) => setMaxNavDifferencePercentInput(value ?? "")}
        value={maxNavDifferencePercentInput}
        kind="percent"
        extraLabel
      />
      <TextInput
        label="حداکثر اختلاف دلتای NAV محاسباتی و دلتای NAV TSE (درصد)"
        name="maxNavDeltaDifferencePercent"
        onChange={(_, value) =>
          setMaxNavDeltaDifferencePercentInput(value ?? "")
        }
        value={maxNavDeltaDifferencePercentInput}
        kind="percent"
        extraLabel
      />
      <div className="w-32 mt-2">
        <Button onClick={submitHandler} text="ثبت" variant="contained" />
      </div>
    </div>
  );
};

export default Settings;
